// @ts-nocheck
import React from 'react';

/**
 * Inline-SVG icon set (lucide-style, 1.6 stroke). Sized via parent font-size
 * by default; pass `size` to override. Color follows `currentColor`.
 */
const make = (paths, viewBox = '0 0 24 24') => function Icon({ size = 16, strokeWidth = 1.6, className, style, ...rest }) {
  return (
    <svg
      viewBox={viewBox}
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
      {...rest}
    >
      {paths}
    </svg>
  );
};

/* ─── Brand / nav ─── */
export const LineChartIcon = make(<>
  <path d="M3 3v18h18" />
  <path d="M7 14l4-4 4 4 5-7" />
</>);
export const BarChartIcon = make(<>
  <path d="M3 3v18h18" />
  <rect x="7" y="10" width="3" height="8" />
  <rect x="12" y="6" width="3" height="12" />
  <rect x="17" y="13" width="3" height="5" />
</>);
export const SlidersIcon = make(<>
  <path d="M4 7h10M18 7h2" />
  <circle cx="16" cy="7" r="2" />
  <path d="M4 17h4M12 17h8" />
  <circle cx="10" cy="17" r="2" />
</>);
export const ClipboardIcon = make(<>
  <rect x="6" y="4" width="12" height="17" rx="2" />
  <path d="M9 4h6v3H9z" />
  <path d="M9 12h6M9 16h4" />
</>);
export const InfoIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="M12 11v5M12 7.5v.01" />
</>);
export const PinIcon = make(<>
  <path d="M12 17v5" />
  <path d="M9 3h6l-1 6 3 3v2H7v-2l3-3-1-6z" />
</>);
export const CreditCardIcon = make(<>
  <rect x="3" y="6" width="18" height="13" rx="2" />
  <path d="M3 10h18M7 15h3" />
</>);
export const ShieldIcon = make(<>
  <path d="M12 3l8 3v6c0 4.5-3.5 8-8 9-4.5-1-8-4.5-8-9V6l8-3z" />
</>);
export const SendIcon = make(<>
  <path d="M22 2 11 13" />
  <path d="m22 2-7 20-4-9-9-4 20-7z" />
</>);
export const PuzzleIcon = make(<>
  <path d="M10 3h4v3a2 2 0 0 0 4 0v0h3v4h0a2 2 0 0 1 0 4h0v3h-4v0a2 2 0 0 0-4 0v0H6v-4h0a2 2 0 0 0 0-4h0V6h4z" />
</>);

/* ─── Topbar / generic ─── */
export const PlusIcon = make(<>
  <path d="M12 5v14M5 12h14" strokeWidth="2" />
</>);
export const XIcon = make(<>
  <path d="M18 6 6 18M6 6l12 12" />
</>);
export const SearchIcon = make(<>
  <circle cx="11" cy="11" r="7" />
  <path d="m20 20-3.5-3.5" />
</>);
export const BellIcon = make(<>
  <path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
  <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
</>);
export const HelpIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .8-1 1.7" />
  <path d="M12 17h.01" />
</>);
export const MenuIcon = make(<>
  <path d="M3 6h18M3 12h18M3 18h18" />
</>);
export const SettingsIcon = make(<>
  <circle cx="12" cy="12" r="3" />
  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9 1.65 1.65 0 0 0 4.27 7.18l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
</>);
export const LogOutIcon = make(<>
  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
  <path d="M16 17l5-5-5-5" />
  <path d="M21 12H9" />
</>);

/* ─── Actions ─── */
export const ChevronDownIcon = make(<><path d="m6 9 6 6 6-6" /></>);
export const ChevronUpIcon = make(<><path d="m6 15 6-6 6 6" /></>);
export const ChevronLeftIcon = make(<><path d="m15 18-6-6 6-6" /></>);
export const ChevronRightIcon = make(<><path d="m9 18 6-6-6-6" /></>);
export const CheckIcon = make(<><path d="M5 13l4 4L19 7" strokeWidth="2" /></>);
export const CheckCircleIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="m8 12 3 3 5-6" />
</>);
export const EditIcon = make(<>
  <path d="M12 20h9" />
  <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
</>);
export const TrashIcon = make(<>
  <path d="M3 6h18" />
  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
  <path d="M10 11v6M14 11v6" />
</>);
export const CopyIcon = make(<>
  <rect x="9" y="9" width="13" height="13" rx="2" />
  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
</>);
export const DownloadIcon = make(<>
  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
  <path d="M7 10l5 5 5-5" />
  <path d="M12 15V3" />
</>);
export const UploadIcon = make(<>
  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
  <path d="M17 8l-5-5-5 5" />
  <path d="M12 3v12" />
</>);
export const ClockIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="M12 8v4l3 2" />
</>);
export const EyeIcon = make(<>
  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
  <circle cx="12" cy="12" r="3" />
</>);
export const EyeOffIcon = make(<>
  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94" />
  <path d="M22 12s-1.5 2.5-4 4.5" />
  <path d="M1 1l22 22" />
  <path d="M9.5 9.5a3 3 0 0 0 4.5 4.5" />
</>);
export const MoreHorizontalIcon = make(<>
  <circle cx="5" cy="12" r="1" />
  <circle cx="12" cy="12" r="1" />
  <circle cx="19" cy="12" r="1" />
</>);
export const MoreVerticalIcon = make(<>
  <circle cx="12" cy="5" r="1" />
  <circle cx="12" cy="12" r="1" />
  <circle cx="12" cy="19" r="1" />
</>);
export const FilterIcon = make(<>
  <path d="M3 4h18l-7 9v6l-4 2v-8L3 4z" />
</>);
export const ArrowUpRightIcon = make(<>
  <path d="M7 17 17 7" />
  <path d="M7 7h10v10" />
</>);
export const ArrowDownRightIcon = make(<>
  <path d="M7 7l10 10" />
  <path d="M17 7v10H7" />
</>);
export const ArrowRightIcon2 = make(<>
  <path d="M5 12h14" />
  <path d="m13 6 6 6-6 6" />
</>);
export const ExternalLinkIcon = make(<>
  <path d="M14 4h6v6" />
  <path d="M10 14 21 3" />
  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
</>);
export const RefreshIcon = make(<>
  <path d="M21 12a9 9 0 1 1-3-6.7" />
  <path d="M21 4v6h-6" />
</>);
export const CodeIcon = make(<>
  <path d="m8 18-5-6 5-6" />
  <path d="m16 6 5 6-5 6" />
</>);
export const CalendarIcon = make(<>
  <rect x="3" y="5" width="18" height="16" rx="2" />
  <path d="M3 10h18M8 3v4M16 3v4" />
</>);
export const AlertTriangleIcon = make(<>
  <path d="M10.3 3.6 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0z" />
  <path d="M12 9v5M12 17.5v.01" />
</>);
export const AlertCircleIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="M12 8v5M12 16.5v.01" />
</>);
export const XCircleIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="m9 9 6 6M15 9l-6 6" />
</>);

/* ─── People / domain ─── */
export const UserIcon = make(<>
  <circle cx="12" cy="8" r="4" />
  <path d="M4 21a8 8 0 0 1 16 0" />
</>);
export const UsersIcon = make(<>
  <circle cx="9" cy="8" r="4" />
  <path d="M2 21a7 7 0 0 1 14 0" />
  <circle cx="17" cy="9" r="3" />
  <path d="M22 21a5 5 0 0 0-8-4" />
</>);
export const MailIcon = make(<>
  <rect x="3" y="5" width="18" height="14" rx="2" />
  <path d="m3 7 9 6 9-6" />
</>);
export const LockIcon = make(<>
  <rect x="4" y="11" width="16" height="10" rx="2" />
  <path d="M8 11V8a4 4 0 0 1 8 0v3" />
</>);
export const PhoneIcon = make(<>
  <path d="M5 4h4l2 5-3 2a12 12 0 0 0 5 5l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
</>);
export const BuildingIcon = make(<>
  <rect x="4" y="3" width="16" height="18" rx="1" />
  <path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M9 16h.01M15 16h.01" />
</>);
export const GlobeIcon = make(<>
  <circle cx="12" cy="12" r="9" />
  <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
</>);
export const LinkIcon = make(<>
  <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" />
  <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
</>);
export const TagIcon = make(<>
  <path d="M20.6 13.6 13.4 20.8a2 2 0 0 1-2.8 0L2 12.2V2h10.2l8.4 8.4a2 2 0 0 1 0 3.2z" />
  <circle cx="7" cy="7" r="1.2" />
</>);

/* Original arrow used by auth submit — keep export name for backward compat. */
export const ArrowRightIcon = ArrowRightIcon2;

/* Route icon map — used by the new Sidebar to render an icon for each route. */
export const navIcons = {
  'chart line': LineChartIcon,
  'sliders horizontal': SlidersIcon,
  'clipboard outline': ClipboardIcon,
  info: InfoIcon,
  thumbtack: PinIcon,
  'credit card outline': CreditCardIcon,
  'mail outline': MailIcon,
  'paper plane outline': SendIcon,
  shield: ShieldIcon,
  puzzle: PuzzleIcon,
};
